import { initiateThirdPartyRedirect } from './third-party-redirect';
import { get9SpokesRedirectURL } from '../../../authorisation-utils/sso-v1-utils/endpoints';
import Config from '../../config-manager';
import * as EventsManager from '../../../system-utils/events-manager';

/**
 * Initiates SSO and performs a redirect to 9Spokes
 *
 * Shows the loading view while redirecting to 9spokes
 * @param path
 */
export const initiate9SpokesRedirect = async (path?: string) => {
  EventsManager.loadingView.showLoadingView();
  const partnerCode = 'NINESPOKES';
  const redirectUrlResponse = await get9SpokesRedirectURL();
  const redirectUrl = redirectUrlResponse.data?.redirectUrl;
  if (redirectUrlResponse.error || !redirectUrl) {
    EventsManager.loadingView.hideLoadingView();
    EventsManager.systemError.publishCriticalError({ error: 'Failed to get redirect url' });
    return;
  }
  const urlParams = {
    ...(path ? { [Config.get<string>('tp_redirect_url_search_params.redirect')]: path } : {}),
  };
  return initiateThirdPartyRedirect(redirectUrl, partnerCode, urlParams).catch(err => {
    EventsManager.loadingView.hideLoadingView();
    // TODO: add tests for this case?
    EventsManager.systemError.publishCriticalError({ error: err.message });
  });
};
